"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8750,6677],{

/***/ 46677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18132);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58598);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3382);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var Breadcrumbs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6384).then(__webpack_require__.bind(__webpack_require__, 46384));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46384)];
    }
  }
});
var Autocomplete = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(9891), __webpack_require__.e(3404)]).then(__webpack_require__.bind(__webpack_require__, 28641));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28641)];
    }
  }
});

var PageHeaderContainer = function PageHeaderContainer(_ref) {
  var title = _ref.title,
      description = _ref.description,
      crumbs = _ref.crumbs,
      linkHref = _ref.linkHref,
      linkTitle = _ref.linkTitle,
      _ref$searchAutoComple = _ref.searchAutoCompleteItems,
      searchAutoCompleteItems = _ref$searchAutoComple === void 0 ? [] : _ref$searchAutoComple,
      domain = _ref.domain,
      resultFormatter = _ref.resultFormatter;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
      display: {
        base: 'none',
        md: 'flex'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Breadcrumbs, {
        items: crumbs
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6, {
      as: "h1",
      fontSize: "2xl",
      fontFamily: "Montserrat-SemiBold",
      textAlign: "left",
      px: "l",
      pt: {
        base: 'l',
        md: '0'
      },
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
      px: "l",
      pt: "s",
      pb: "l",
      display: {
        md: 'flex'
      },
      tabIndex: -1,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
        width: {
          base: '100%',
          md: '65%'
        },
        textAlign: "left",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
          marginTop: "s",
          color: "baseNeutral.700",
          fontFamily: "Montserrat-Medium",
          fontSize: "md",
          className: "landing-text",
          display: "inline",
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), linkHref && linkTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_2__/* .TextLink */ .hh, {
          href: linkHref,
          title: linkTitle,
          color: "primaryGreen.600",
          fontFamily: "Montserrat-SemiBold",
          marginLeft: "0.75rem",
          children: [linkTitle, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* .ArrowForwardIcon */ .mr, {})]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
        width: {
          base: '100%',
          md: '35%'
        },
        alignItems: "center",
        pl: {
          base: '0',
          md: 'l'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Autocomplete, {
          items: searchAutoCompleteItems,
          disableFilter: true,
          apiPath: domain === 'sell' ? 'search/sell/term' : 'search/rent/term',
          onSelect: function onSelect(selected) {
            return domain === 'sell' ? next_router__WEBPACK_IMPORTED_MODULE_3___default().push(selected) : next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/noleggio-a-lungo-termine/".concat(selected.replace(' ', '/')));
          },
          placeholder: isMobile ? t('pageHeaderContainer:placeholderMobile') : t('pageHeaderContainer:placeholder'),
          notFoundText: t('pageHeaderContainer:nothingFound'),
          withOverlay: true,
          mt: {
            base: 4,
            md: 0
          },
          resultFormatter: resultFormatter
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PageHeaderContainer);

/***/ })

}]);